const isFuture = (time = '00:00') => {
  const d = new Date();
  return (
    Number(time.replace(':', '')) > Number(d.getHours() + '' + d.getMinutes())
  );
};

export default isFuture;
